(function() {
    $(document).ready(function() {

        $('.div24Sprite.c24Rotation').each(function (index, element) {
            const $element = $(element);

            $element.data('position', 0);
            c24UpdateSiegelBox($element, 0);

            $element.on('click', '.box24Prev, span.prev', function(e) {
                e.preventDefault();
                c24UpdateSiegelBox($element, -1);
            });
            $element.on('click', '.box24Next, span.next', function(e) {
                e.preventDefault();
                c24UpdateSiegelBox($element, 1);
            });
        });
    });

    function c24UpdateSiegelBox(element, difference)
    {
        const logos = $('span', element);
        let position = element.data('position') + difference;
        if (position < 0) {
            position = logos.length - 1;
        } else if (position == logos.length) {
            position = 0;
        }

        logos.removeClass('prev');
        logos.removeClass('current');
        logos.removeClass('next');

        let prevPosition;
        let nextPosition;

        if (position == 0) {
            prevPosition = logos.length - 1;
        } else {
            prevPosition = position - 1;
        }
        if (position == logos.length - 1) {
            nextPosition = 0;
        } else {
            nextPosition = position + 1;
        }

        $(logos[prevPosition]).addClass('prev');
        $(logos[position]).addClass('current');
        $(logos[nextPosition]).addClass('next');
        element.data('position', position);
    }
})();
